import { Box } from '@material-ui/core';
import React from 'react';
import styles from './SGSMenuLinkAnimated.module.scss';
import classnames from 'classnames';

type Props = {
    image: any;
    alt: string;
    active?: Boolean;
    className?: string;
};

const SGSMenuLinkAnimated: React.FC<Props> = ({ image, alt, active, className, children }) => {
    return (
        <div className={classnames(styles.menuLinkContainer, active && styles.menuLinkActive, className)}>
            <div className={styles.menuLinkText}>
                <div className="mx-2">{children}</div>
                <Box className={styles.menuLinkIcon}>
                    <img src={image} alt={alt} />
                </Box>
            </div>
            <div className={styles.menuLinkAnimatedBar}></div>
        </div>
    );
};

export default SGSMenuLinkAnimated;
